<div class="maintenance-page__notification-container">
  <agr-extended-notification notificationType="warning" [title]="'app.maintenance.notification-title' | translate">
    <div class="spacing--margin-top" [innerHTML]="'app.maintenance.notification-content' | translate"></div>
    <div class="spacing--margin-top" [innerHTML]="'app.maintenance.notification-thank-you' | translate"></div>
  </agr-extended-notification>
</div>
